export default async function signOut() {
	let url = `${process.env.REACT_APP_API_URL}logout`;

	const response = await fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		}
	})

	if (response.status === 200) {
		return;
	} else {
		throw response.statusText;
	}
};